import { TitleUI } from "./TitleUI";
import { getOwnBrand } from "../../utils/product/getOwnBrand";
import { StandardProps } from "../componentMap";
import { sanitiseTitle } from "./sanitiseTitle";
import { useSeo } from "../../hooks/useSeo/useSeo";
import { ElementType } from "react";
import { useRouter } from "next/router";
import { formatM2MTitle } from "../../utils/product/formatM2MTitle";
import { isM2MRomanBlindOrCurtain } from "@/utils/product/isMadeToMeasure";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { isMultiVariants } from "@/utils/product/isMultiVariants.ts";

export function Title({
  product,
  configProps,
  flags,
}: Pick<StandardProps, "product" | "configProps" | "flags">) {
  const ownBrand = getOwnBrand(product);

  const { variant } = useVariant(product);
  const hasMultiVariants = isMultiVariants(product);

  const overrideElement = configProps?.overrideElement as ElementType;
  const otherBrand =
    !ownBrand && product?.brand?.name?.toLowerCase() !== "unbranded"
      ? product.brand?.name
      : "";

  const { heading } = useSeo(product);
  let title = sanitiseTitle(heading, ownBrand, otherBrand);

  const router = useRouter();
  if (isM2MRomanBlindOrCurtain(product)) {
    title = formatM2MTitle(title, router.query?.roman === "true");
  }

  const simplifiedBeautyTitle =
    (configProps?.simplifiedBeautyTitle as boolean) ?? false;
  return (
    <TitleUI
      title={title}
      ownBrand={ownBrand}
      otherBrand={otherBrand || ""}
      element={overrideElement}
      simplifiedBeautyTitle={simplifiedBeautyTitle}
      flags={flags}
      productId={product.aliases?.pimProductId}
      skuId={variant?.aliases?.skuId}
      isMultiSku={hasMultiVariants}
    />
  );
}
